import { render, staticRenderFns } from "./Catalogo.vue?vue&type=template&id=7cade2bc&scoped=true&"
import script from "./Catalogo.vue?vue&type=script&lang=js&"
export * from "./Catalogo.vue?vue&type=script&lang=js&"
import style0 from "./Catalogo.vue?vue&type=style&index=0&id=7cade2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cade2bc",
  null
  
)

export default component.exports